import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser, fetchUser } from './../../redux/userSlice';
import { swalAlert } from 'utils';
import { Link, useNavigate } from 'react-router-dom';
import UserSignInModal from 'components/user/UserSignInModal';
import Header_Cart from 'components/cart/Header_Cart';
import { AiOutlineMenu } from 'react-icons/ai';
import { BiBook } from 'react-icons/bi';

import Header_User from './../user/Header_User';
import HeaderUserMenuContent from './../user/inc/HeaderUserMenuContent';

import './header.css';

const Header = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = useSelector((state) => state.user);
  const config = useSelector((state) => state.config);

  const [menuOpen, setMenuOpen] = useState(false);
  const [showSignInModal, setShowSignInModal] = useState(false);

  const navLinks = [
    {
      to: "/formalities/templates",
      label: "Nos formalités"
    },
    {
      to: "/cms/about-us",
      label: "Qui sommes-nous ?"
    },
    {
      to: "/cms/faq",
      label: "FAQ"
    }
    ,
    {
      to: "/contact",
      label: "Contact"
    }
  ];

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const handleSignOut = () => {
    swalAlert('Vous êtes déconnecté.');
    dispatch(clearUser());
    setMenuOpen(false);
    navigate('/');
  };

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <header
      className={`App-header ${menuOpen ? 'responsive-menu-on' : ''}`}
      id="app-header"
    >
      <div id="header-main">

        {/* LEFT */}
        <div id='header-main-left'></div>

        {/* CENTER */}
        <div id='header-main-center'>
          <Link className='logo' to="/">
            <img src='/img/logo.png' alt={config.site_nom} />
          </Link>
        </div>

        {/* RIGHT DESKTOP */}
        <div
          id='header-main-right'
          className='h-100 d-flex flex-column align-items-end justify-content-between'
        >
          <div className='right-modules mt-3 d-flex justify-content-end  gap-3'>
            <Header_User />
            {user.isSignedIn &&
              <Header_Cart />
            }
          </div>

          <div className='d-none d-lg-flex'>
            <ul className="list-unstyled d-flex justify-content-end mb-0 gap-0">
              {navLinks.map((item, index) => (
                <li key={index} className='nav-item'>
                  <Link
                    to={item.to}
                    className="nav-link"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

          </div>
        </div>
      </div>
      {/* BURGER */}
      <button className="burger-menu " onClick={toggleMenu}>
        <AiOutlineMenu size={30} />
      </button>
      {/* RESPONSIVE MENU */}
      <div id="header-responsive-menu">
        <div className='logo' ></div>
        <ul className="list-unstyled d-flex flex-column gap-3">
          {navLinks.map((item, index) => (
            <li key={index}>
              <Link
                to={item.to}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </Link>
            </li>
          ))}
          <li><hr /></li>
          {/* 🔁 Réutilisation du même composant métier */}
          <li className='d-flex flex-column gap-3'>
            <HeaderUserMenuContent
              user={user}
              t={t}
              onSignIn={() => {
                setMenuOpen(false);
                setShowSignInModal(true);
              }}
              onSignOut={handleSignOut}
              onNavigate={handleNavigate}
            />
          </li>
        </ul>

      </div>

      {/* SignIn Modal */}
      {showSignInModal && (
        <UserSignInModal
          show={showSignInModal}
          onClose={() => setShowSignInModal(false)}
          onSuccess={() => {
            setShowSignInModal(false);
            dispatch(fetchUser());
          }}
        />
      )}
    </header>
  );
});

export default Header;